import { mapGetters } from 'vuex'
import FilterMember from '@/components/elements/FilterMember'
import airaApi from '@/api/aira-aiful.js'
import MemberItem from './MemberItem'
import * as XLSX from 'xlsx'
import moment from 'moment'
import DatepickerCustomDialog from '@/components/elements/DatepickerCustomDialog.vue'

export default {
  data: function () {
    var headers = []
    headers = headers.concat([
      { text: this.$t(''), value: '' },
      { text: this.$t('uid'), value: 'uid' },
      { text: this.$t('line_name'), value: 'first_name' },
      { text: this.$t('customer_name'), value: 'th_name' },
      { text: this.$t('account_no'), value: 'account_no' },
      { text: this.$t('Id Card'), value: 'id_no' },
      { text: this.$t('card_no_amoney'), value: 'card_no' },

      { text: this.$t('prompt_pay'), value: 'prompt_pay' },
      { text: this.$t('bank_name'), value: 'bank_name' },
      { text: this.$t('bank_account_no'), value: 'bank_account_no' },
      { text: this.$t('bank_account_status'), value: 'bank_account_status' },

      { text: this.$t('account_binding_status'), value: 'member_status' },
      { text: '', sortable: false }
    ])
    return {
      loading: true,
      showAdvance: false,
      total_user: '',
      users: [],
      showExport: false,
      exportpagecount: 0,
      pageNumber: 1,
      pagetmp: 1,
      filter: {
        uid: '',
        line_id: '',
        line_name: '',
        th_name: '',
        account_no: '',
        id_no: '',
        card_no: '',
        status: '',
        statusFilter: {
          label: this.$t('All'),
          value: 'all'
        },
        statusBankFilter: {
          label: this.$t('All'),
          value: 'all'
        },
        registertimestamp_from: '',
        registertimestamp_to: '',
        bank_name: '',
        bank_account_no: '',
        prompt_pay: '',
        bank_account_status: ''
      },
      headers,
      pagination: { rowsPerPage: -1, sortBy: '' },
      limit: 100,
      offset: 0
    }
  },
  components: {
    FilterMember,
    MemberItem,
    DatepickerCustomDialog
  },
  mounted: async function () {
    this.initCustomer()
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    }),
    pagelength() {
      if (this.total_user) {
        return Math.ceil(this.total_user / 100)
      } else {
        return 1
      }
    },
    filteredHeader() {
      Array.prototype.insert = function (index) {
        index = Math.min(index, this.length)
        arguments.length > 1 &&
          this.splice.apply(this, [index, 0].concat([].pop.call(arguments))) &&
          this.insert.apply(this, arguments)
        return this
      }

      return this.headers
    },
    usersFormat() {
      if (this.users && Object.keys(this.users).length > 0) {
        return this.users
      } else {
        return []
      }
    }
  },
  methods: {
    async initCustomer() {
      var vm = this
      vm.$store.dispatch('loadStatus')
    },
    clearSearch: function () {
      this.filter = {
        uid: '',
        line_name: '',
        th_name: '',
        account_no: '',
        id_no: '',
        card_no: '',
        status: '',
        registertimestamp_from: '',
        registertimestamp_to: '',
        statusFilter: {
          label: this.$t('All'),
          value: 'all'
        },
        statusBankFilter: {
          label: this.$t('All'),
          value: 'all'
        },
        bank_name: '',
        bank_account_no: '',
        prompt_pay: '',
        bank_account_status: ''
      }
      this.$forceUpdate()

      this.onSearch()
    },
    onSearch: function () {
      var vm = this
      vm.$validator.validate().then(async (result) => {
        if (!result) {
          vm.goToErrorInput()
          return false
        }
        vm.offset = 0
        vm.hasNext = true
        vm.users = []
        vm.loading = true
        try {
          const users = await vm.getLoadUsers(vm.limit, vm.offset)
          vm.users = vm.users.concat(users)
        } catch (error) {
          console.error(error)
        }
        vm.loading = false
      })
    },
    async getLoadUsers(limit, offset) {
      const vm = this
      try {
        const pageid = this.selectedBot.pageid
        const tmpFilter = JSON.parse(JSON.stringify(vm.filter))
        delete tmpFilter['statusFilter']
        delete tmpFilter['statusBankFilter']
        let data = {
          ...tmpFilter,
          limit: limit,
          offset: offset
        }
        const response = await airaApi.getAllMembers(pageid, data)
        if (response.status === 200 && response.data.message === 'get users success') {
          const responseData = response.data.result
          vm.total_user = response.data.total
          return responseData
        }
        return response
      } catch (error) {
        vm.total_user = 0
        vm.this.users
        console.error(error)
      }
    },
    getFormatDate: function (date, format) {
      return moment(date).format(format)
    },
    changePage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        vm.offset = vm.pageNumber * 100 - 100
        this.getMoreCustomers()
      }
    },
    async getMoreCustomers() {
      var vm = this
      vm.loading = true
      try {
        const users = await vm.getLoadUsers(vm.limit, vm.offset)
        vm.users = users
      } catch (error) {
        console.error(error)
      }
      vm.loading = false
    },
    exportCustomer: function (offset = 0) {
      let vm = this
      var limit = 5000
      vm.loading = true
      vm.getLoadUsers(limit, offset).then(
        function (users) {
          if (users && users.length > 0) {
            var json = []
            $.each(users, function (index, val) {
              var userData = {
                Uid: val.uid ? val.uid : '-',
                'Line Name': val.first_name ? val.first_name : '-',
                'Customer Name': val.th_name ? val.th_name : '-',
                'Account No': val.account_no ? val.account_no : '-',
                'ID Card': val.id_no ? val.id_no : '-',
                'Card No': val.card_no ? val.card_no : '-',
                status:
                  val.member_status === 'active'
                    ? 'ผูกบัญชี'
                    : val.member_status === 'inactive'
                    ? 'ยกเลิกผูกบัญชี'
                    : '-',
                'Regis Date': val.regis_date
                  ? moment(val.regis_date).format('DD/MM/YYYY HH:mm')
                  : '-',
                'Update Address Date': val.update_address_date
                  ? moment(val.update_address_date).format('DD/MM/YYYY HH:mm')
                  : '-',
                'Update Phone Date': val.update_phone_date
                  ? moment(val.update_phone_date).format('DD/MM/YYYY HH:mm')
                  : '-',
                'Cancel Regis Date': val.unregis_date
                  ? moment(val.unregis_date).format('DD/MM/YYYY HH:mm')
                  : '-',
                Promptpay: val.prompt_pay ? val.prompt_pay : '-',
                'Bank Account No': val.bank_account_no ? val.bank_account_no : '-',
                'Bank Name': val.bank_name ? val.bank_name : '-',
                'Bank Account Type': val.bank_account_type ? val.bank_account_type : '-',
                'Update Bank Date': val.update_bank_date ? val.update_bank_date : '-',
                'Bank Account Status': val.bank_account_status ? val.bank_account_status : '-'
              }

              json.push(userData)
            })
            const dataWS = XLSX.utils.json_to_sheet(json)
            const wb = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(wb, dataWS)
            XLSX.writeFile(wb, 'zwiz-member.xlsx')
            vm.loading = false
          } else {
            vm.loading = false
          }
        },
        function () {
          vm.loading = false
        }
      )
    },

    onExportCustomer() {
      this.exportpagecount = Math.ceil(this.total_user / this.exportlimit)

      if (this.exportpagecount > 1) {
        this.showExport = true
      } else {
        this.exportCustomer(0)
      }
    }
  },
  watch: {
    pagination: {
      async handler() {
        this.loading = true
        try {
          this.users = await this.getLoadUsers(this.limit, this.offset)
        } catch (error) {
          console.error(error)
        }
        this.loading = false
      },
      deep: true
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/view/template/AiraAiful/Members.js